<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <!-- <label
            class="inputLabel"
            style="white-space: nowrap; width: 200px"
          >账号ID/账号名称：</label> -->
          <el-input v-model="oceanQuery.keyword" placeholder="请输入账号ID/账号名称" />
        </div>
        <div class="searchContainer">
          <!-- <label
            class="inputLabel"
            style="white-space: nowrap; width: 40px"
          >组织：</label> -->
          <el-input v-model="oceanQuery.advertiser_name" placeholder="请输入组织" />
        </div>
        <div class="searchContainer">
          <!-- <label
            class="inputLabel"
            style="white-space: nowrap; width: 40px"
          >时间：</label> -->
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="pickerTime"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="info"
          plain
          icon="el-icon-refresh-left"
          @click="handleSearchReset"
        >
          重置
        </el-button>

        <div class="searchContainer" style="float: right">
          <el-button
            type="warning"
            class="filter-item"
            @click="exportQuery"
          >导出</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            class="filter-item"
            @click="detlteAll"
          >批量删除账户项目</el-button>
          <el-button
            class="filter-item"
            @click="stopAll"
          ><i
            class="imgIcon"
            :style="`background-image: url(${imglist[1]})`"
          />批量暂停账户项目</el-button>
          <el-button
            class="filter-item"
            @click="getURLData"
          ><i
            class="imgIcon"
            :style="`background-image: url(${imglist[0]})`"
          />授权</el-button>
          <el-button
            class="filter-item"
            @click="pullAll"
          ><i
            class="imgIcon"
            :style="`background-image: url(${imglist[1]})`"
          />批量拉取素材报表</el-button>
          <el-button
            icon="el-icon-edit-outline"
            class="filter-item"
            @click="editepiwek"
          >批量修改备注</el-button>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between"
        :row-key="rowKey"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column
          type="selection"
          align="center"
          width="55"
          :reserve-selection="true"
        /> -->
        <el-table-column prop="advertiser_name" label="广告主名称">
          <template scope="scope">
            <p class="overflow" :title="scope.row.advertiser_name">
              {{ scope.row.advertiser_name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="agent_name" label="组织">
          <template scope="scope">
            <p class="overflow" :title="scope.row.agent_name">
              {{ scope.row.agent_name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
        >
          <template scope="scope">
            <div>
              <span v-if="!(remarkItemId && remarkItemId.id === scope.row.id)">{{ scope.row.remark }}</span>
              <input
                v-else
                v-model="remarkTextid"
                autofocus
                style="width: 300px;padding: 5px;border: 1px solid #ccc;"
                @blur="blur3"
              >
              <i
                v-if="!(remarkItemId && remarkItemId.id === scope.row.id)"
                class="el-icon-edit"
                style=" margin-left: 13px; font-size: 19px; cursor: pointer;"
                @click="(remarkItemId = scope.row),(remarkTextid = scope.row.remark)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="company" label="公司">
          <template scope="scope">
            <p class="overflow" :title="scope.row.company">
              {{ scope.row.company }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="account_id" label="账号ID" width="270">
          <template scope="scope">
            <p class="overflow" :title="scope.row.account_id">
              {{ scope.row.account_id }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="account_status_text" label="账号状态">
          <template scope="scope">
            <p class="overflow" :title="scope.row.account_status_text">
              {{ scope.row.account_status_text }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="first_industry_name" label="第一个工业名称">
          <template scope="scope">
            <p class="overflow" :title="scope.row.first_industry_name">
              {{ scope.row.first_industry_name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="second_industry_name" label="第二个工业名称">
          <template scope="scope">
            <p class="overflow" :title="scope.row.second_industry_name">
              {{ scope.row.second_industry_name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间">
          <template scope="scope">
            <p class="overflow" :title="scope.row.created_at">
              {{ scope.row.created_at }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="type"
          label="账号类型"
          width="200"
        >
          <template scope="scope">
            <span>{{ scope.row.type === 1 ? '微信' : '腾讯广告' }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="money"
          label="账户余额(元)"
          align="center"
        >
          <template scope="scope">
            <el-button
              type="text"
              :loading="moneyLoading"
            />
            <span v-show="!moneyLoading">{{ scope.row.money }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="advertiser_detail"
          label="首次消耗日期"
          width="170"
        >
          <template scope="scope">
            <p class="overflow" :title="scope.row.advertiser_detail.first_use_date">{{ scope.row.advertiser_detail.first_use_date }}</p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="advertiser_detail"
          label="最近消耗日期"
          width="170"
        >
          <template scope="scope">
            <p class="overflow" :title="scope.row.advertiser_detail.last_use_date">{{ scope.row.advertiser_detail.last_use_date }}</p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="advertiser_relation"
          label="运营人员"
          width="200"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.advertiser_relation.map(item => item.relation_name).join('、')"
            >
              {{ scope.row.advertiser_relation.map(item => item.relation_name).join('、') }}
            </p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="advertiser_relation"
          label="主要运营人员"
        >
          <template scope="scope">
            <p>{{ scope.row.advertiser_relation | filterMaster }}</p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-dropdown
              trigger="click"
              @command="(command)=>handleCommand(command,scope.row)"
            >
              <span
                class="el-dropdown-link"
                style="cursor: pointer;"
              >
                更多
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link
                    :to="{
                      path: `/massiveAdvertising/customer/accountList/tencentAdqAdvertManage/advertiserList`,
                      query: {
                        account_id: scope.row.account_id,
                        ad_name: scope.row.advertiser_name,
                        ad_id: scope.row.id
                      }
                    }"
                  >
                    广告计划列表
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                    :to="{
                      path: `/massiveAdvertising/customer/accountList/tencentAdqAdvertManage/advertisingGroup`,
                      query: {
                        account_id: scope.row.account_id,
                        ad_name: scope.row.advertiser_name,
                        ad_id: scope.row.id
                      }
                    }"
                  >
                    广告组列表
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <CodeScanning
      ref="codeScanning"
      :title="
        typeValue === 'QQ'
          ? 'QQ扫码登录'
          : typeValue === '微信'
            ? '微信扫码登录'
            : typeValue
      "
      :myobj="mStyle[typeValue] || {}"
      @openedEnd="openedEnd"
      @reset="reset"
    />
    <el-dialog title="账号类型" :visible.sync="dialogVisible" width="30%">
      <el-select v-model="type" placeholder="请选择">
        <el-option
          v-for="item in optionstype"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="window__footer">
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="pull" mode="pull" @addPull="addPull" />
    </el-dialog>
    <el-dialog
      title="批量暂停"
      :visible.sync="dialogVisibleStop"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="stop" mode="stop" @addPull="addStop" />
    </el-dialog>
    <el-dialog
      title="批量删除"
      :visible.sync="dialogVisibledetlte"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="detelr" mode="stop" @addPull="adddeter" />
    </el-dialog>
    <el-dialog
      title="填写密码"
      :visible.sync="password_visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="400px"
      append-to-body
    >
      <p style="color: red;font-size: 19px">*该操作会删除选择的广告主下所有的项目</p>
      请输入密码:
      <el-input
        v-model="mima"
        style="margin-top: 20px;width: 280px"
        placeholder="请填写密码"
        show-password
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="success"
          :loading="buto_loading"
          @click="passwordCommit"
        >提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量修改备注"
      :visible.sync="dialogVisibleremark"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <choosedialog
        ref="choosedialogview"
        @companycallback="companycallback"
      />
    </el-dialog>
  </div>
</template>

<script>
import detailsList from './components/details.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { /* advertiserList, */ getQrCode } from '@/api/customer.js'
import {
  /* getURL, */ getBalance,
  qqShouQuan,
  syncNotes,
  adqShouQuan,
  advertisersjl, stopCopyAd, sprdeletecover, advertiserchangeremark
} from '@/api/report/accountManagement'
import {
  advertiserExport,
  getAccountList,
  toGrantAuthorization
} from '@/api/massiveAdvertising/accountList.js'
import CodeScanning from './codeScanningLogin/index.vue'
import axios from 'axios'
import md5 from 'js-md5'
import choosedialog from './components/choosedialog.vue'
const mStyle = {
  QQ: {
    left: '-119px',
    top: '-76px',
    width: '424px'
  },
  微信: {
    left: '-189px',
    top: '-43px',
    width: '568px'
  },
  MP扫码登录: {
    top: '-45px',
    left: '-189px',
    width: '568px'
  },
  同步备注: {
    top: '-100px',
    left: '-189px',
    width: '568px'
  },
  ADQ扫码登录: {
    top: '-139px',
    left: '-341px',
    width: '888px'
  }
}

export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    CodeScanning,
    detailsList,
    choosedialog
  },
  filters: {
    // 用于过滤主要运营人员 如果 is_master 为 1 则 relation_name 就是主要运营成员
    filterMaster(currentData) {
      for (let i = 0; i < currentData.length; i++) {
        if (currentData[i].is_master === 1) {
          return currentData[i].relation_name
        }
      }
    }
  },
  data() {
    return {
      type: 1,
      optionstype: [
        {
          value: 1,
          label: '小说'
        },
        {
          value: 2,
          label: '短剧'
        },
        {
          value: 3,
          label: '通用'
        }
      ],
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        account_name: null,
        type: null,
        account_status: null,
        page: null, // 当前页码
        pageSize: null // 显示数据条数
      },
      // 请求参数
      oceanQuery: {
        keyword: '',
        page: 1,
        page_size: 10,
        advertiser_name: '',
        created_at_start: '',
        created_at_end: ''
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '微信公众号'
        },
        {
          value: 2,
          label: '腾讯广告(adq)'
        }
      ],
      options: [
        {
          label: '腾讯', // 客户系统状态 枚举值
          options: [
            {
              value: 'CUSTOMER_STATUS_NORMAL',
              label: '有效'
            },
            {
              value: 'CUSTOMER_STATUS_PENDING',
              label: '待审核'
            },
            {
              value: 'CUSTOMER_STATUS_DENIED',
              label: '审核不通过'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN',
              label: '封停'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN_TEMPORARILY',
              label: '临时冻结'
            }
          ]
        },
        {
          label: '微信', // 微信广告账户授权状态 枚举值
          options: [
            {
              value: 'STATUS_PRE_AUTHORIZATION',
              label: '预授权'
            },
            {
              value: 'STATUS_CONFIRM_AUTHORIZATION',
              label: '确认授权/已绑定'
            },
            {
              value: 'STATUS_REQUEST_CANCELATION',
              label: '请求撤销授权'
            }
          ]
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      mStyle: mStyle,
      dialogVisiblePull: false,
      dialogVisibleStop: false,
      imglist: [
        require('@/assets/images/10.巨量3.0--账户列表/授权.png'),
        require('@/assets/images/10.巨量3.0--账户列表/批量拉去素材列表.png')
      ],
      selectlist: [],
      selectlistsend: [],
      dialogVisibledetlte: false,
      mima: '',
      buto_loading: false,
      password_visible: false,
      allsetrwe: [],
      remarkItemId: null,
      remarkTextid: null,
      dialogVisibleremark: false,
      date: []
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    async addPull(obj) {
      console.log('obj:', obj)
      await advertisersjl(obj)
      this.$message.success('批量拉取成功')
      this.dialogVisiblePull = false
    },
    async addStop(obj) {
      console.log('obj:', obj)
      await stopCopyAd(obj)
      this.$message.success('批量暂停成功')
      this.dialogVisibleStop = false
    },
    async adddeter(obj) {
      console.log('obj:', obj)
      // await sprdeletecover(obj)
      // this.$message.success('批量删除成功')
      // this.dialogVisibledetlte = false
      this.password_visible = true
      this.allsetrwe = []
      this.allsetrwe = obj.account_ids
    },
    passwordCommit() {
      if (!this.mima) {
        return this.$message.error('请填写密码')
      }
      this.buto_loading = true
      setTimeout(function() {
        this.buto_loading = false
      }, 2000)
      sprdeletecover({
        account_ids: this.allsetrwe,
        password: md5(this.mima)
      })
        .then(res => {
          if (res.code === 0) {
            this.mima = ''
            this.buto_loading = false
            this.dialogVisibledetlte = false
            this.password_visible = false
            this.$message.success('批量删除成功')
          }
          console.log(res)
        })
        .catch(err => {
          this.buto_loading = false
          console.log(err)
        })
    },
    handleClose() {
      this.dialogVisiblePull = false
      this.dialogVisibleStop = false
      this.dialogVisibledetlte = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },
    stopAll() {
      this.dialogVisibleStop = true
      this.$nextTick(() => {
        this.$refs.stop.sendr()
      })
    },
    detlteAll() {
      this.dialogVisibledetlte = true
      this.$nextTick(() => {
        this.$refs.detelr.sendr()
      })
    },
    exportQuery() {
      // 校验 keyword 和 advertiser_name 至少有一个不为空
      // if (!this.oceanQuery.keyword && !this.oceanQuery.advertiser_name) {
      //   this.$message.error('请至少输入账号或组织')
      //   return
      // }
      console.log(this.oceanQuery)
      advertiserExport(this.oceanQuery).then(response => {
        console.log(response)
        if (response.code === 0) {
          this.$message.success(response.message)
        }
      })
    },
    async confirm() {
      const data = await toGrantAuthorization({
        type: this.type
      })
      window.open(data.data.url)
      this.dialogVisible = false
      this.type = 1
    },
    // 获取账户列表
    getAdvertiserList() {
      this.loading = true
      getAccountList(this.oceanQuery).then((res) => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    async getURLData() {
      this.dialogVisible = true
    },
    // 获取用户余额
    getBalanceData() {
      this.moneyLoading = true
      getBalance(this.accountIdsQuery).then((res) => {
        const arr = []
        for (let i = 0; i < res.data.length; i++) {
          arr[i] = res.data[i].account
        }
        for (let i = 0; i < this.tableData.length; i++) {
          const index = arr.indexOf(this.tableData[i].account_id)
          if (index !== -1) {
            this.tableData[i].money = res.data[index].balance
          }
        }
        this.accountIdsQuery = []
        this.moneyLoading = false
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.type = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.oceanQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.oceanQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.oceanQuery.page = 1
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.oceanQuery = {}
      this.date = []
      this.getAdvertiserList()
    },
    handleCommand(command, data) {
      switch (command) {
        case 'dataReport':
          this.$router.push({
            name: 'massiveAdvertisingEffectData',
            params: {
              account_id: data.account_id,
              account_name: data.account_name
            }
          })
          break
      }
    },
    async openedEnd(callback) {
      let src = null
      try {
        if (this.typeValue === 'MP扫码登录') {
          const data = await getQrCode({
            cancelToken: new axios.CancelToken((c) => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'QQ') {
          const data = await qqShouQuan({
            cancelToken: new axios.CancelToken((c) => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === '同步备注') {
          const data = await syncNotes({
            cancelToken: new axios.CancelToken((c) => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'ADQ扫码登录') {
          const data = await adqShouQuan({
            cancelToken: new axios.CancelToken((c) => {
              this.source = c
            })
          })
          src = data.data.data
        }
        ronyu(src)
      } catch (err) {
        this.source && this.source()
        callback('err')
      }

      function ronyu(src) {
        const img = new Image()
        const src1 = 'data:image/png;base64,' + src
        img.src = src1
        img.onload = () => {
          callback(src1)
        }
      }
    },
    reset(callback) {
      callback()
      this.source && this.source()
    },
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    batchDelete() {
      console.log('this.selectlist', this.selectlist)
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.account_id
      })
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          sprdeletecover({
            account_ids: this.selectlistsend
          }).then(res => {
            this.$message({
              type: 'success',
              message: `${res.message}`
            })
            this.selectlist = []
            this.$refs.multipleTable.clearSelection()
            setTimeout(() => {
              this.getAdvertiserList()
            }, 2000)
          })
        })
        .catch(() => {})
    },
    async blur3() {
      if (this.remarkItemId.consume !== this.remarkTextid) {
        try {
          await advertiserchangeremark({ account_ids: [this.remarkItemId.account_id], remark: this.remarkTextid })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.remarkItemId = null
          this.remarkTextid = null
        }
      }
      this.remarkItemId = null
      this.remarkTextid = null
    },
    editepiwek() {
      this.dialogVisibleremark = true
    },
    companycallback() {
      this.dialogVisibleremark = false
      this.getAdvertiserList()
    },
    pickerTime(val) {
      console.log('val', val)
      this.oceanQuery.created_at_start = val[0]
      this.oceanQuery.created_at_end = val[1]
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .block {
  justify-content: left;
}
.window__footer {
  margin-top: 20px;
}

.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 20px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 100px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.imgIcon {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  background-size: cover;
  // filter: hue-rotate(90deg);
  filter: grayscale(100%);
}
</style>
